module.exports = __webpack_public_path__ + "img/1554822666.ae37e4a8.jpg";